import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import COMPANY_LOGO from "../../assets/images/logos/logo.png";
import Form from "../../components/form/Form";
import { getTenantDetails, login, reset } from "../../redux/slice/auth/authSlice";
import { getObjectKeys } from "../../utils/validators/validators";
import { flashMessage as flash } from "./../../utils/flash/index";
import { isEmptyObject } from "./../../utils/validators/validators";
import useInputChange from "./../../utils/hooks/useInputChange";
import TextInput from "../../components/form/inputs/TextInput";
import Label from "../../components/form/labels/Label";

const Login = () => {
  const [userInput, setUserInput] = useState({
    staff_id: "",
    password: "",
  });
  // const {staff_id, password} = userInput
  const [error, setError] = useState({});
  const passwordRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [input, handleChange] = useInputChange(
    userInput,
    setUserInput,
    error,
    setError
  );

  // const from = location.state?.from?.pathname || "/";
  const { user, isLoading, isError, isSuccess, message, changePassword } = useSelector(
    (state) => state.auth
  );

  // Input Change Controller
  // const inputChangeHandler = (e) => {
  //     let {name, value} = e.target
  //     // value = name === 'remember_me' ? e.target.checked : e.target.value

  //     // remove item from state object using key
  //     if(getObjectKeys(error).length !== 0){
  //         setError(current => {
  //             const copy = {...current}
  //             delete copy[name]
  //             return copy
  //         })
  //     }

  //     // Set input fields
  //     setUserInput(() => {
  //         return {...userInput, [name] : value}
  //     })
  // }

  // Login Controller
  const handleSubmit = () => {
    let credentials = {
      staff_id: userInput.staff_id,
      password: userInput.password,
    };
    if (isEmptyObject(error)) {      
      dispatch(login(credentials));
    }
  };

  // Show Password Controller
  const handleShowPassword = () => {
    let type = passwordRef.current.getAttribute("type");
    let newAttribute = type === "password" ? "text" : "password";
    passwordRef.current.setAttribute("type", newAttribute);
    let passwordIcon = document.querySelector(".password-icon");
    passwordIcon.classList.toggle("mdi-eye-off");
  };

  useEffect(() => {
    dispatch(getTenantDetails())
  }, [dispatch])
  

  // console.log(isSuccess);
  useEffect(() => {
    console.log(changePassword);
    
    if (isSuccess && changePassword) {
      console.log('here');
      setUserInput({ ...userInput, password: "" });
      navigate("/reset-password", { state: {staff_id: userInput.staff_id}}, { replace: true });
    }
    if (isSuccess && user) {
      setUserInput({ ...userInput, password: "" });
      navigate("/admin/dashboard", { replace: true });
    }
    if (isLoading) {
      flash("loading", "Authenticating...");
    }
    if (isError) {
      setUserInput({ ...userInput, password: "" });
      // flash('error', message)
    }
    dispatch(reset());
  }, [user, isLoading, isError, message, changePassword]);  

  // if (tenantLoading || tenantError) {
  //   return null;
  // }
  return (
    <div className='loading authentication-bg'>
      <div className='account-pages pt-2 pt-sm-5 pb-4 pb-sm-5'>
        <div className='login-bg-divider'></div>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-xxl-4 col-lg-5'>
              <div className='card'>
                {/* <!-- Logo --> */}
                <div className='card-header pt-2 pb-2 text-center bg-liht'>
                  <Link to='/' className='position-absolte mt-2'>
                    {/* <span>
                      <img src={tenant?.data?.image} alt='' height='100' />
                    </span> */}
                    <span>
                      <img src={COMPANY_LOGO} alt='' height='100' />
                    </span>
                  </Link>
                  <h4 className='text-warning text-uppercase m-2'>
                    PRUDENT CHOICE
                  </h4>
                </div>

                <div className='card-body p-4'>
                  <Form
                    setError={setError}
                    submitHandler={handleSubmit}
                    values={userInput}
                  >
                    <div className='mb-2'>
                      <label htmlFor='emailaddress' className='form-label'>
                        Staff ID
                      </label>
                      <TextInput
                        id='staff id'
                        textName='staff id'
                        name='staff_id'
                        inputValue={input.staff_id}
                        inputChangeHandler={handleChange}
                        error={error}
                        placeholder='Enter staff id'
                        type='text'
                        ref={passwordRef.current}
                      />
                      {error.staff_id && (
                        <span className='invalid-feedback'>
                          {error.staff_id}
                        </span>
                      )}
                    </div>

                    <div className='mb-3'>
                      <Label
                        htmlFor='password'
                        className='form-label'
                        labelName='Password'
                      />
                      <div className='input-group input-group-merge'>
                        {/* <TextInput
                                            id='password'
                                            textName='password'
                                            name='password'
                                            inputValue={input.password}
                                            inputChangeHandler={handleChange}
                                            error={error}
                                            placeholder='Enter your password'
                                            type='password'
                                            ref={passwordRef.current}
                                        /> */}
                        <input
                          textname='password'
                          name='password'
                          onChange={handleChange}
                          value={input.password}
                          placeholder='Enter your password'
                          type='password'
                          className={`form-control ${
                            error.staff_id && "is-invalid"
                          }`}
                          id='password'
                          required=''
                          autoComplete=''
                          ref={passwordRef}
                        />
                        {!error.password && (
                          <div
                            className='input-group-text'
                            data-password='false'
                          >
                            <span
                              className='password-icon mdi mdi-eye'
                              onClick={handleShowPassword}
                            ></span>
                          </div>
                        )}
                        <span className='invalid-feedback'>
                          {error.password}
                        </span>
                      </div>
                    </div>

                    <div className='mb-3 mb-0 text-center'>
                      <button
                        disabled={
                          Object.keys(error).length > 0 || isLoading
                            ? true
                            : false
                        }
                        className='btn w-100 btn-primary fs-5'
                      >
                        {" "}
                        Log In{" "}
                      </button>
                    </div>
                  </Form>
                </div>
                {/* <!-- end card-body --> */}
              </div>
              {/* <!-- end card --> */}
            </div>
            {/* <!-- end col --> */}
          </div>
          {/* <!-- end row --> */}
        </div>
        {/* <!-- end container --> */}
      </div>
      {/* <!-- end page --> */}
    </div>
  );
};

export default Login;
